import React from 'react';
import EmptyState from '../../EmptyState';
import { classes } from '../Table.st.css.js';
export const TableEmptyState = props => (React.createElement("div", { className: classes.emptyStateContainer },
    React.createElement(EmptyState, Object.assign({}, props))));
TableEmptyState.displayName = 'Table.EmptyState';
TableEmptyState.propTypes = Object.assign({}, EmptyState.propTypes);
TableEmptyState.defaultProps = Object.assign({}, EmptyState.defaultProps);
//# sourceMappingURL=TableEmptyState.js.map